import React from "react";
import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import { theme } from "@theme";
import LIcon from "@components/LIcon";

type EyeProps = {
  accessibilityLabel?: string;
  color?: string;
  disabled: boolean;
  onPress: () => void;
  showPassword: boolean;
  testID?: string;
};

const Eye = ({
  accessibilityLabel,
  color,
  disabled,
  onPress,
  showPassword,
  testID,
}: EyeProps) => {
  return (
    <LBox position="absolute" right={theme.spacing.s3} padding="s1">
      <LPressable
        sentryEventName="login_show_password_toggle"
        onPress={onPress}
        disabled={disabled}
        accessibilityLabel={accessibilityLabel}
        testID={testID}
        shouldDismissKeyboard={false}
      >
        <LIcon
          colors={color ? { color } : undefined}
          disabledOpacity={color ? 1 : undefined}
          name={showPassword ? "close_eye" : "open_eye"}
          size={24}
          enabled={!disabled}
        />
      </LPressable>
    </LBox>
  );
};

export default Eye;
